import React from 'react'

const AbReports = () => {
  return (
    <section className="db-reports-section">
      <div className="db-reports-inner">
        <span className="db-reports-badge">TOP PICKS</span>
        <h1 className="db-reports-title">AB</h1>
        <h2 className="db-reports-subtitle">Anjeer Bites</h2>
        <div className="db-reports-underline"></div>
      </div>
    </section>
  )
}

export default AbReports